'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CreateClient;

var _clients = require('./clients');

var _clients2 = _interopRequireDefault(_clients);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CreateClient(opts) {
  var options = {
    host: 'https://api.flow.io'
  };

  if (typeof opts === 'string') {
    options.auth = opts;
  } else {
    options = Object.assign({}, options, opts);
  }

  return new _clients2.default(options);
}